export default "/build/images/1head.png?03edf8cfa2685179d2735c857ddaf43d";